<template>
	<div v-if="area.group_trainings.length" class="row q-mb-lg">
		<div
			class="col-12 text-h6"
			:class="$q.platform.is.desktop || $q.platform.is.ipad ? 'components-title' : ''"
		>
			{{ area.name }}
		</div>
		<div class="col-12" v-if="$q.platform.is.desktop || $q.platform.is.ipad">
			<q-carousel
				v-model="slide"
				swipeable
				animated
				padding
				arrows
				infinite
				keep-alive
				transition-prev="slide-right"
				prev-icon="fal fa-angle-left"
				transition-next="slide-left"
				next-icon="fal fa-angle-right"
				control-color="grey-7"
				class="no-shadow"
				height="auto"
			>
				<q-carousel-slide
					:name="index + 1"
					class="column no-wrap"
					v-for="(page, index) in paginatedCourses"
					:key="`p${index}`"
				>
					<div class="row q-col-gutter-md">
						<div class="col-3" v-for="(course, index) in page" :key="`i${index}`">
							<course :course="course" />
						</div>
					</div>
				</q-carousel-slide>
			</q-carousel>
		</div>

		<div class="col-12" v-if="$q.platform.is.mobile && !$q.platform.is.ipad">
			<q-scroll-area
				horizontal
				:visible="false"
				class="scroll-hidden q-mt-md scroll-area-height-portfolio"
			>
				<div class="row no-wrap q-col-gutter-md" style="width: 100vw">
					<div
						class="col-xs-5 col-sm-3"
						v-for="(course, index) in area.group_trainings"
						:key="`i${index}`"
					>
						<course :course="course" />
					</div>
				</div>
			</q-scroll-area>
		</div>
	</div>
</template>

<script>
import Course from 'components/portfolio/Course'

export default {
	name: 'AreaPortfolio',

	props: ['area'],

	data() {
		return {
			slide: 1,
		}
	},

	components: {
		course: Course,
	},

	computed: {
		paginatedCourses() {
			let chunks = []
			let i = 0
			let n = this.area?.group_trainings.length

			while (i < n) chunks.push(this.area.group_trainings.slice(i, (i += 4)))
			return chunks
		},
	},
}
</script>

<style></style>
